"use strict";
var async_1 = require('../scheduler/async');
var timestamp_1 = require('../operators/timestamp');
/**
 * @param scheduler
 * @return {Observable<Timestamp<any>>|WebSocketSubject<T>|Observable<T>}
 * @method timestamp
 * @owner Observable
 */
function timestamp(scheduler) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    return timestamp_1.timestamp(scheduler)(this);
}
exports.timestamp = timestamp;
//# sourceMappingURL=timestamp.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxjs/operator/timestamp.js
// module id = 1536
// module chunks = 9